import StudentPackageAPI from '@/apis/business/student/student-package-api.js'

export default {
  namespaced: true,

  state: {
    studentPackage: null
  },

  getters: {},

  mutations: {
    /**
     * @description set dữ liệu cho state studentPackage
     * @author PVThang
     * @param {*} state
     * @param {*} studentPackage
     */
    setStudentPackage (state, studentPackage) {
      state.studentPackage = studentPackage
    }
  },

  actions: {
    /**
     * @author PVThang
     * @param {*} context
     * @param {object} param
     * @description Lấy StudentPackage
     */
    async getStudentPackage (context, param) {
      const res = await StudentPackageAPI.getAsync('owner')
      context.commit('setStudentPackage', res?.Data)
      return res?.Data
    }
  }
}
